import { callApi } from 'loankeeper-common/api'

export const search = (params) =>
  callApi('client_search', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
// export const add = (params) =>
//   callApi('client_add', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
// export const getRequiredFields = (params) =>
//   callApi('client_reqfields', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
export const getSelects = () =>
  callApi('client_lookups', {
    params: {},
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const checkDublicate = (params) =>
  callApi('client_checkduplicate', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const submitAddClientFormData = ({ action, ID, hash, ...rest }) =>
  callApi('client_add', {
    params: {
      action,
      ClientID: ID,
      HashSum_ClientID_: hash,
    },
    body: rest,
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const submitClientValidation = ({ action, ID, hash, ...rest }) =>
//   callApi('client_whitelist', {
//     params: {
//       action: 'clientadd',
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//     },
//     body: rest,
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const viewValidation = ({ ClientID, WHLSessionID, HashSum_WHLSessionID_ }) =>
//   callApi('client_whitelist', {
//     params: {
//       action: 'view',
//       ClientID,
//       WHLSessionID,
//       HashSum_WHLSessionID_,
//     },
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// used in DetailsContainer/sagas/fetcher.js
// TODO: remove
export const details = ({ ID, hash, page, StartDate, EndDate, additionalParams }) =>
  callApi('client_view', {
    params: {
      ClientID: ID,
      HashSum_ClientID_: hash,
      page,
      StartDate,
      EndDate,
      ...additionalParams,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const sendSMS = (ID, hash, smsText, phoneNumber) =>
//   callApi('client_oper', {
//     params: {
//       page: 'smssend',
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       Comment: smsText,
//       Phone: phoneNumber,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const sendNewPinSMS = (ID, hash, phoneNumber) =>
//   callApi('client_oper', {
//     params: {
//       page: 'newpincode',
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       Phone: phoneNumber,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addRelation = (
//   ID,
//   hash,
//   relatedClientID,
//   relatedClientHash,
//   clientRelType,
//   relatedClientRelType,
//   Node,
//   cfield,
// ) => {
//   return callApi('client_oper_post', {
//     params: {
//       page: 'relationadd',
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//     },
//     method: 'post',
//     body: {
//       RLClientID: relatedClientID,
//       HashSum_RLClientID_: relatedClientHash,
//       RLTypeID: clientRelType,
//       RLTypeID2: relatedClientRelType,
//       NodeID: Node,
//       CField1: cfield,
//     },
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
// }

// export const deleteRelation = (ClientID, clientHash, RLClientID, RelationID, RelationClientHash) =>
//   callApi('client_oper_post', {
//     params: {
//       page: 'relationdelete',
//       ClientID,
//       HashSum_ClientID_: clientHash,
//     },
//     method: 'post',
//     body: {
//       ID: RelationID,
//       RLClientID,
//       HashSum_RLClientID_: RelationClientHash,
//     },
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addToBlackList = (ID, hash, comment) =>
//   callApi('client_oper', {
//     params: {
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       Comment: comment,
//       page: 'blacklist',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoAddToBlackList = (ID, hash) =>
//   callApi('client_oper', {
//     params: {
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       page: 'blacklistundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addToWatchlist = (ID, hash, comment) =>
//   callApi('client_oper', {
//     params: {
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       Comment: comment,
//       page: 'watchlist',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoAddToWatchlist = (ID, hash) =>
//   callApi('client_oper', {
//     params: {
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       page: 'watchlistundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addTag = (params) =>
//   callApi('client_oper', {
//     params: {
//       ...params,
//       page: 'tagadd',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deleteTag = (params) =>
//   callApi('client_oper', {
//     params: {
//       ...params,
//       page: 'tagdelete',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addPermission = (params) =>
//   callApi('client_oper', {
//     params: {
//       ...params,
//       page: 'accesspermadd',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deletePermission = (params) =>
//   callApi('client_oper', {
//     params: {
//       ...params,
//       page: 'accesspermdelete',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const validatePinCode = (ID, hash, pinCode) =>
//   callApi('client_oper', {
//     params: {
//       ClientID: ID,
//       HashSum_ClientID_: hash,
//       page: 'mclpincodevalidate',
//       Comment: pinCode,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addIdDoc = ({
//   ClientID,
//   hash,
//   IDCardTypeID,
//   IDCardIssuerID,
//   IDCardIssuerTxt,
//   IDNumber,
//   IssueDate,
//   ExpireDate,
//   DFDoc,
//   FileID,
//   HashSum_FileID_,
// }) =>
//   callApi('client_oper', {
//     params: {
//       ClientID,
//       HashSum_ClientID_: hash,
//       page: 'iddocadd',
//       IDCardTypeID,
//       IDCardIssuerID,
//       IDCardIssuerTxt,
//       IDNumber,
//       IssueDate,
//       ExpireDate,
//       DFDoc: +DFDoc,
//       FileID,
//       HashSum_FileID_,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const editIdDoc = ({
//   ClientID,
//   hash,
//   ID,
//   IDCardTypeID,
//   IDCardIssuerID,
//   IDCardIssuerTxt,
//   IDNumber,
//   IssueDate,
//   ExpireDate,
//   DFDoc,
//   FileID,
//   HashSum_FileID_,
// }) =>
//   callApi('client_oper', {
//     params: {
//       ClientID,
//       HashSum_ClientID_: hash,
//       page: 'iddocedit',
//       ID,
//       IDCardTypeID,
//       IDCardIssuerID,
//       IDCardIssuerTxt,
//       IDNumber,
//       IssueDate,
//       ExpireDate,
//       DFDoc: +DFDoc,
//       FileID,
//       HashSum_FileID_,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deleteIdDoc = ({ ClientID, hash, ID }) =>
//   callApi('client_oper', {
//     params: {
//       ClientID,
//       HashSum_ClientID_: hash,
//       ID,
//       page: 'iddocdelete',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const checkReqFields = ({ ClientID, HashSum_ClientID_, ID }) =>
  callApi('client_oper', {
    params: {
      page: 'checkreqfields',
      ClientID,
      HashSum_ClientID_,
      ID,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const contactVerifySendSMS = ({ PersonalNo, CellPhone, ClientID, ClientHash }) =>
  callApi('client_contact_verify', {
    params: {
      action: 'send_sms',
      PersonalNo,
      CellPhone,
      ClientID,
      HashSum_ClientID_: ClientHash,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const contactVerifySMS = ({ PersonalNo, CellPhone, Code, ClientID, ClientHash }) =>
  callApi('client_contact_verify', {
    params: {
      action: 'verify_sms',
      PersonalNo,
      CellPhone,
      Code,
      ClientID,
      HashSum_ClientID_: ClientHash,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
